var exports = {
  "kL": "x31de4314--8dfcac--container",
  "my": "x31de4314--8dfcac--avatar",
  "Yu": "x31de4314--8dfcac--text-block",
  "YX": "x31de4314--8dfcac--title-row",
  "DD": "x31de4314--8dfcac--title",
  "WD": "x31de4314--8dfcac--labels",
  "ui": "x31de4314--8dfcac--info-row",
  "Sn": "x31de4314--8dfcac--room-links",
  "tu": "x31de4314--8dfcac--room-link",
  "o1": "x31de4314--8dfcac--actions",
  "lZ": "x31de4314--8dfcac--phone",
};

module.exports = exports;
